// extracted by mini-css-extract-plugin
export default {"add-notes-form":"style_add-notes-form__vwuuW","addNotesForm":"style_add-notes-form__vwuuW"};